import dayjs from "dayjs"
import { useCallback } from "react"
import { usePolyglot } from "src/contexts"

/*
 * render just the time from a date-time string in a locale appropriate way
 */
export function useDisplayTime(): (s: string | number) => string {
  const polyglot = usePolyglot()

  return useCallback(
    (value: string | number) => new Intl.DateTimeFormat(
      polyglot.locale(),
      {
        timeStyle: "short",
      },
    ).format(dayjs(value).toDate()),
    [polyglot],
  )
}
